import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppShell from "./components/AppShell";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Members from "./pages/Members";
import MemberDetail from "./pages/MemberDetail";
import Opportunities from "./pages/Opportunities";
import OpportunityNew from "./pages/OpportunityNew";
import OpportunityDetail from "./pages/OpportunityDetail";
import Deals from "./pages/Deals";
import DealDetail from "./pages/DealDetail";
import Meetings from "./pages/Meetings";
import MeetingDetail from "./pages/MeetingDetail";
import SynergyMap from "./pages/SynergyMap";
import QuarterlyReview from "./pages/QuarterlyReview";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";
import Onboarding from "./pages/Onboarding";
import Applications from "./pages/Applications";
import InstallPrompt from "./components/InstallPrompt";

const TOAST_OPTIONS = {
  style: {
    background: "#1A1A1A",
    border: "1px solid rgba(201,168,76,0.35)",
    color: "#F0EDE8",
  },
};

function App() {
  return (
    <div className="App">
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={TOAST_OPTIONS}
      />
      <BrowserRouter>
        <AuthProvider>
          <InstallPrompt />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/members" element={<Members />} />
              <Route path="/members/:id" element={<MemberDetail />} />
              <Route path="/opportunities" element={<Opportunities />} />
              <Route path="/opportunities/new" element={<OpportunityNew />} />
              <Route path="/opportunities/:id" element={<OpportunityDetail />} />
              <Route path="/deals" element={<Deals />} />
              <Route path="/deals/:id" element={<DealDetail />} />
              <Route path="/meetings" element={<Meetings />} />
              <Route path="/meetings/:id" element={<MeetingDetail />} />
              <Route path="/synergy-map" element={<SynergyMap />} />
              <Route path="/quarterly-review" element={<QuarterlyReview />} />
              <Route path="/profile" element={<Profile />} />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute requireAdmin>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/applications"
                element={
                  <ProtectedRoute requireAdmin>
                    <Applications />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
